import { Component, Input } from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { LANG_LABELS } from '../../../core/i18n/language';

/**
 * Botón que rota el idioma activo (ES → EN → PT → ES). Extraído del toggle
 * que vivía inline en dashboard.component (sidebar) para poder reutilizarlo
 * también en las pantallas de login/registro, donde antes no había ninguna
 * forma de cambiar de idioma.
 */
@Component({
  selector: 'app-lang-switcher',
  standalone: false,
  templateUrl: './lang-switcher.component.html',
  styleUrl: './lang-switcher.component.scss'
})
export class LangSwitcherComponent {
  /** 'menuItem' calca el estilo de los ítems del sidebar (dashboard); 'standalone' es un botón autónomo (auth). */
  @Input() variant: 'menuItem' | 'standalone' = 'standalone';

  constructor(private languageService: LanguageService) {}

  get label(): string {
    return LANG_LABELS[this.languageService.lang()];
  }

  toggle(): void {
    this.languageService.toggle();
  }
}
